import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { toCurrency, mapState } from '@deerplusofficial/pos-helper';
import { Button as ButtonBase } from '@deerplusofficial/pos-components';
import styled from 'styled-components';
import Info from './Info';
import InfoSection from './InfoSection';
import actions from '../../actions';

const Button = styled(ButtonBase).attrs({ accent: true, dense: true })`
  font-size: 18px;
`;

class InfoSectionPoints extends PureComponent {
  render() {
    const {
      order: { points },
      toggleMemberModal,
    } = this.props;

    if (points <= 0) return null;

    return (
      <InfoSection>
        <Info negative label="世代 Point">
          <Button onClick={toggleMemberModal}>{toCurrency(-points)}</Button>
        </Info>
      </InfoSection>
    );
  }
}

const {
  modal: { toggle: toggleMemberModal },
} = actions.member;

export default connect(
  mapState(['order']),
  { toggleMemberModal }
)(InfoSectionPoints);



// WEBPACK FOOTER //
// ./src/components/Info/InfoSectionPoints.js